import React from 'react';
import {FreePlaySlideComponent} from "../../../components/video-slides/components/free-play-slide/free-play-gambling-short.component";
import {SlideBaseRenderer} from "./slide-base.renderer";

export class FreePlaySlideRenderer extends SlideBaseRenderer {
    render(): React.ReactElement {
        return <FreePlaySlideComponent key={this.uniqueKey} />
    }
}